export const SET_PRELOADED = "SET_PRELOADED";
export const GET_GEO_DATA = 'GET_GEO_DATA';

export const SET_COUNTRY = 'SET_COUNTRY';

export const SET_STATE = 'SET_STATE';

export const SET_LANGUAGE = 'SET_LANGUAGE';

export const GET_LOCALE = 'GET_LOCALE';
export const SET_LOCALE = 'SET_LOCALE';
export const UPDATE_LOCALE = 'UPDATE_LOCALE';

export const GET_TRANSLATIONS = 'GET_TRANSLATIONS';
export const SET_TRANSLATIONS = 'SET_TRANSLATIONS';

export const GET_COUNTRIES = 'GET_COUNTRIES';
export const SET_COUNTRIES = 'SET_COUNTRIES';

export const SET_MARKETS = 'SET_MARKETS';

export const SET_MARKET_CURRENCY = 'SET_MARKET_CURRENCY';

export const SET_LANG_OPTIONS = 'SET_LANG_OPTIONS';

export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';

export const SET_REGIONS = 'SET_REGIONS';
export const SET_BILLING_REGIONS = 'SET_BILLING_REGIONS';
export const SET_SHIPPING_METHODS = 'SET_SHIPPING_METHODS';
export const SET_FILTERED_SHIPPING_METHODS = 'SET_FILTERED_SHIPPING_METHODS';



// WEBPACK FOOTER //
// ./src/store/actions/types/localeActionTypes.js